import React, { useContext, useState, useEffect } from "react";
import { CurrentUserContext } from "../../context/CurrentUserContext.js";
import { useLocation } from "react-router-dom";
import { courseRegistry } from "../../courses/courseRegistry";
import "./Account.css";
import EditProfile from "./EditProfile.jsx";
import { useTranslation } from "../../utils/hooks/translateHook.js";
import ChangePassword from "./ChangePassword.jsx";
import upgrade from "../../images/icons/upgradeIcon.svg";
import profile from "../../images/icons/ProfileIcon.svg";
import edit from "../../images/icons/EditIcon.svg";
import changePassword from "../../images/icons/passwordIcon.svg";

const Account = () => {
  const { currentUser, setCurrentUser } = useContext(CurrentUserContext);
  const t = useTranslation();
  const [formData] = useState(currentUser || {});
  const [activeSection, setActiveSection] = useState("profile"); //  profile | edit | password
  const location = useLocation();

  let themeClass = "theme-global";
  Object.keys(courseRegistry).forEach((courseSlug) => {
    if (location.pathname.includes(courseSlug)) {
      themeClass = `theme-${courseSlug}`;
    }
  });

  if (!currentUser) return <p>Loading profile...</p>;

  return (
    <div className= "back-account">
     <div className={`profile-bar ${themeClass}`}>
      <h3 className="title"> {t("greeting")} {currentUser?.name} {currentUser?.lastname}</h3>

      <div className="account">
        <div className="profile-buttons">
          <div className={`menu-item ${activeSection === "profile" ? "active" : ""}`} 
              onClick={() => setActiveSection("profile")}>
              <img src={profile} className="icon_account" alt="profile" />
              <span>{t("profile")}</span>
          </div>
          <div className={`menu-item ${activeSection === "edit" ? "active" : ""}`}
              onClick={() => setActiveSection("edit")}>
              <img src={edit} className="icon_account" alt="edit" />
              <span>{t("editProfile")}</span>
          </div>
          <div className={`menu-item ${activeSection === "password" ? "active" : ""}`}
              onClick={() => setActiveSection("password")}>
              <img src={changePassword} className="icon_account" alt="password" />
              <span>{t("changePassword")}</span>
          </div>
        </div>

        <div className="profile-content">
          {activeSection === "profile" && (
            <div className="profile-info">
              <ul>
                <li> <p>{t("email")}</p> <strong className="email">{currentUser?.email || ""}</strong></li>
                <li> <p>{t("memberSince")}</p> <strong> {formData.createdAt? new Date(formData.createdAt).toLocaleDateString(): ""}</strong></li>
                {/* <li> <p>{t("subscription")}</p> <strong> {currentUser.subscriptionLevel}</strong></li> */}
                <li> <p>{t("location")}</p> <strong> {currentUser?.country || ""} {currentUser?.city || ""}</strong></li>
                <li> <p>{t("phone")}</p> <strong> {currentUser?.phone || ""}</strong></li>
              </ul>
              
              {/*currentUser.subscriptionLevel === 100 && */}
              {(
                <div className="upgrade-wrapper">
                  <button className="upgrade-button"
                    onClick={() => window.location.href = "/upgrade"}>
                    <img src={upgrade} className="icon_account" alt="profile" />
                    {t("Upgrade_Plan")}
                  </button> 
                </div>
              )}
            </div>
          )}
          {activeSection === "edit" && (<EditProfile user={currentUser} onUpdate={setCurrentUser} onClose={() => setActiveSection("profile")}/>)}
          {activeSection === "password" && ( <ChangePassword onClose={() => setActiveSection("profile")} />)}
      </div>
    </div>
    </div>
  </div>
  );
};

export default Account;
